import {InterviewTypeApiName} from '../../common/interview-type';
import {
    ISessionChallenge,
    ISessionChallengeItem,
    ISessionCode,
    ISessionCodeItem,
} from '../../redux/modules/session/reducer';
import {DASHBOARD_URL, TUTORIAL} from '../../utils/config';
import {getLanguage} from '../session-editor/data';

export interface ICurrentStateResponse extends ISessionChallenge, ISessionCode {
    challengeId: string;
    currentState: string;
    dashboardUrl: string;
    hadLanguageChanged: boolean;
    hadQuestionChanged: boolean;
    hadTestsUnlocked: boolean;
    interviewId: string;
    interviewType: InterviewTypeApiName;
    intervieweeUserId: string;
    isInterviewer: boolean;
    isQuestionNew: boolean;
    rootPath: string;
    showConsoleScrollHint: boolean;
    showRunCodeHint: boolean;
    showVideoHint: boolean;
    startTime: string;
    token: string;
    videoRoom: string;
}

const challenge1: ISessionChallengeItem[] = TUTORIAL ? TUTORIAL.challenge : [{
  type: 'md',
  title: 'Question',
  content: require('./questions/1/question.md'),
}, {
  type: 'md',
  title: 'Hints',
  content: require('./questions/1/hint.md'),
}, {
  type: 'md',
  title: 'Answer',
  content: require('./questions/1/answer.md'),
}];

const challenge2: ISessionChallengeItem[] = TUTORIAL ? TUTORIAL.challenge : [{
  type: 'md',
  title: 'Question',
  content: require('./questions/2/question.md'),
}];

const initialLanguage = 'Java';

export const currentState: ICurrentStateResponse = {
    challenge: challenge1,
    challengeId: 'question1',
    code: {
        language: initialLanguage,
        initial: getLanguage(initialLanguage).initialCode,
    },
    currentState: 'InProgress',
    dashboardUrl: DASHBOARD_URL || 'https://www.pramp.com/#/signup',
    hadLanguageChanged: false,
    hadQuestionChanged: false,
    hadTestsUnlocked: false,
    interviewId: Date.now() + '_user1_user2',
    interviewType: TUTORIAL ? TUTORIAL.interviewType : InterviewTypeApiName.Algorithms,
    intervieweeUserId: '',
    isInterviewer: true,
    isQuestionNew: false,
    rootPath: 'root_path',
    showConsoleScrollHint: false,
    showRunCodeHint: false,
    showVideoHint: false,
    startTime: (new Date()).toISOString(),
    token: 'some-token',
    videoRoom: 'video_room',
};

export function currentStateResponse(): ICurrentStateResponse {
  return currentState;
}

export function swapRolesResponse(isInterviewer: boolean): ICurrentStateResponse {
  if (isInterviewer) {
    return {
      ...currentState,
      isInterviewer: false,
      challenge: challenge2,
    };
  } else {
    return currentState;
  }
}

export function languageResponse(language: string): ISessionCodeItem {
  return {
    initial: getLanguage(language).initialCode,
    language,
  };
}
